// extracted by mini-css-extract-plugin
export default {"PurchaseMain":"Purchase_PurchaseMain__sfAsT","PurchaseMainPaymentArea":"Purchase_PurchaseMainPaymentArea__RuxQg"};